import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dialog, DropdownButton, FormLabel, Loader, __deprecated_Select, generateBaseClasses } from '../../../components/common';
import { dictionary } from '../../../lang';
import { MAP_COLOR } from '../../../lib/constants';
import { assignTeamZips, unassignTeamZips, selectAreaTeamZips } from '../../../redux';
const AreaDetailsPanel = ({ open, setOpen, zipcodeFeatures, setZipcodeFeatures, selectedFeatures, teamOptions, teamColors, firstSelectedTeam, }) => {
    const [chosenTeam, setChosenTeam] = useState(firstSelectedTeam);
    const [qualifiedAddressesTotal, setQualifiedAddressesTotal] = useState(0);
    const dispatch = useDispatch();
    const { isLoading } = useSelector(selectAreaTeamZips);
    useEffect(() => {
        setChosenTeam(firstSelectedTeam);
    }, [firstSelectedTeam]);
    const title = (_jsxs(_Fragment, { children: [_jsx("div", { className: "text-xl", children: "Selected zip information" }), _jsxs("div", { className: "mt-2", children: [_jsx(FormLabel, { label: dictionary.TEAM, htmlFor: "teamsList" }), _jsx("div", { className: "mt-0.5", children: _jsx(__deprecated_Select, { className: "text-gray-500", value: chosenTeam, id: "teamsList", name: "teamsList", type: "select", selectOptions: teamOptions, onChange: (event) => setChosenTeam(Number(event.target.value)), baseClasses: generateBaseClasses('select') }) })] })] }));
    const unassignAction = () => {
        dispatch(unassignTeamZips.request({
            teamId: chosenTeam,
            zips: selectedFeatures,
            callback: () => {
                updateFeatures(MAP_COLOR.TEAM_UNASSIGNED, null);
                setOpen(false);
            },
        }));
    };
    const assignAction = () => {
        dispatch(assignTeamZips.request({
            teamId: chosenTeam,
            zips: selectedFeatures,
            callback: () => {
                updateFeatures(teamColors[chosenTeam], chosenTeam);
                setOpen(false);
            },
        }));
    };
    const updateFeatures = (newColor, teamId) => {
        const newZipFeatures = [...zipcodeFeatures];
        for (const thisFeature of newZipFeatures) {
            const featureId = thisFeature.properties.zip;
            if (selectedFeatures.includes(featureId)) {
                const newProperties = { ...thisFeature.properties, team_id: teamId };
                const newStyle = { ...thisFeature.style, color: newColor };
                const newFeature = { ...thisFeature, properties: newProperties, style: newStyle };
                newZipFeatures.splice(newZipFeatures.indexOf(thisFeature), 1, newFeature);
            }
        }
        setZipcodeFeatures(newZipFeatures);
    };
    // Helper function to determine if the user selected zipcodes
    // from multiple teams
    const hideUnassign = () => {
        let teamId = null;
        for (const thisSelection of selectedFeatures) {
            for (const thisZip of zipcodeFeatures) {
                if (thisZip.properties.zip === thisSelection) {
                    if (thisZip.properties.team_id === null) {
                        continue;
                    }
                    // Any selection that is unassigned means hide
                    if (!thisZip.properties.team_id) {
                        return true;
                    }
                    if (!teamId) {
                        // Getting here means that a team_id exists and can be set
                        teamId = thisZip.properties.team_id;
                    }
                    // If there is a different team selected
                    if (teamId && (thisZip.properties.team_id !== teamId)) {
                        return true;
                    }
                }
            }
        }
        // After going through all selections and teamId was never set
        // means that all selections are unassigned
        return !teamId;
    };
    const getActionButton = () => {
        const options = [
            {
                label: 'Assign',
                onClick: assignAction,
            },
        ];
        if (!hideUnassign()) {
            options.push({
                label: 'Unassign',
                onClick: unassignAction,
            });
        }
        return (!isLoading && (_jsx(DropdownButton, { options: options })));
    };
    useEffect(() => {
        if (selectedFeatures.length) {
            let total = 0;
            for (const thisFeature of zipcodeFeatures) {
                for (const thisSelection of selectedFeatures) {
                    if (thisFeature.properties.zip === thisSelection) {
                        total += thisFeature.properties.qualified_addresses;
                    }
                }
            }
            setQualifiedAddressesTotal(total);
        }
    }, [selectedFeatures, zipcodeFeatures]);
    return (_jsx(Dialog, { open: open, title: title, setOpen: setOpen, defaultPosition: { x: 100, y: 300 }, actionButton: getActionButton(), canBeClosed: true, children: isLoading ? (_jsx(Loader, {})) : (_jsx("table", { className: "w-full table-autodivide-y", children: _jsxs("tbody", { className: "divide-y", children: [_jsx("tr", { children: _jsx("td", { colSpan: 2, className: "py-2 text-xl", children: "Information" }) }), _jsxs("tr", { children: [_jsx("td", { className: "py-2 text-sm text-gray-500", children: "Qualified Addresses" }), _jsx("td", { className: "py-2 text-sm float-right", children: new Intl.NumberFormat('en-US').format(qualifiedAddressesTotal) })] })] }) })) }));
};
AreaDetailsPanel.propTypes = {
    open: PropTypes.bool,
    setOpen: PropTypes.func,
    zipcodeFeatures: PropTypes.array,
    setZipcodeFeatures: PropTypes.func,
    selectedFeatures: PropTypes.array,
    teamOptions: PropTypes.array,
    teamColors: PropTypes.object,
    firstSelectedTeam: PropTypes.number,
};
export default AreaDetailsPanel;
